// extracted by mini-css-extract-plugin
var _1 = "l6hk6ez2OUbtGZhTtAdA";
var _2 = "PgSbBsWPfRNI3Mh1Duub";
var _3 = "GeyTxkpV0URsZWtRXr8e";
export { _1 as "textAlert", _2 as "textBold", _3 as "title" }
